import Footer from "../../../navigation/footerContainer";
import MyPropertiesContainer from "./myPropertiesContainer";


export default function MyPropertiesPage() {
    return (
        <>
            <MyPropertiesContainer />
            <Footer />
        
        </>
    )

}